export const CREDIT = 'credit'
export const DEBT = 'debt'

export const creditTypesOptions = [
    { value: CREDIT, label: 'Crédito (pagar)' },
    { value: DEBT, label: 'Débito (descontar)' },
]